import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig'

// ** Get Schedule Comment
export const getComments = createAsyncThunk('appComments/getComments', async (id) => {
  const response = await axios.get(`/api/daily_work_comments/details/${id}`)
  return response.data
})

// ** Get Schedule Comment
export const getCommentList = createAsyncThunk('appCommentList/getCommentList', async (params) => {
  const response = await axios.get('/api/daily_work_comments', {params})
  return response.data
})

// ** Fetch single Comments
export const getSingleComments = createAsyncThunk('appComments/getSingleComments', async (id) => {
  const response = await axios.get(`/api/daily_work_comments/${id}`)
  return response.data
})

// ** Add Schedule Comment
export const addComment = createAsyncThunk(
  'appSchedule/addComment', // Corrected to match the name in createAsyncThunk
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
        if (!data) {
            throw new Error("Invalid data");
          }
      const response = await axios.post('/api/daily_work_comments',data )
      return response.data
      
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// ** Delete Schedule
export const deleteComment = createAsyncThunk('appSchedules/deleteComment', async (id, { getState, dispatch }) => {
  const response = await axios.delete(`/api/daily_work_comments/${id}`)
  dispatch(getComments(getState().schedule.params)) // Refresh Schedule list after deletion
  return response.data
})

export const ScheduleSlice = createSlice({
  name: 'Schedule',
  initialState: {
    singleData: {}, // Data for a single Schedule
    data: [], // Data for a list of Schedules
    total: 0,
    params: {},
    allData: [], // (Optional) Store all Schedule data if needed
    status: 'idle',
    message: null,
    errors: null
  },
  reducers: {
    resetSingleSchedule: (state) => {
      state.singleData = {} // Reset single Schedule data
    },
    resetStateIdele: (state) => {
      state.status = 'idle' // Reset status to idle
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple Comments
    builder
      .addCase(getComments.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getComments.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.allData = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getComments.rejected, (state, action) => {
        state.status = 'failed'
        state.message = null
        state.errors = null
      })

     // ** Fetch Single Comments
    builder
    .addCase(getSingleComments.pending, (state) => {
      state.status = 'loading'
      state.message = null;
      state.errors = null
    })
    .addCase(getSingleComments.fulfilled, (state, action) => {
      state.status = 'succeeded'
      state.data = action.payload.data
      state.total = action.payload.total
      state.params = action.payload.params
    })
    .addCase(getSingleComments.rejected, (state, action) => {
      state.status = 'failed'
      // state.message = action.payload.message
      // state.errors = action.payload.errors
    })

     // ** Fetch list of Comments
     builder
     .addCase(getCommentList.pending, (state) => {
       state.status = 'loading'
       state.message = null;
       state.errors = null
     })
     .addCase(getCommentList.fulfilled, (state, action) => {
       state.status = 'succeeded'
       state.data = action.payload.data
       state.total = action.payload.total
       state.params = action.payload.params
     })
     .addCase(getCommentList.rejected, (state, action) => {
       state.status = 'failed'
       state.message = action.payload.message
       state.errors = action.payload.errors
     })

    // ** Add Schedule Cost
    builder
      .addCase(addComment.pending, (state) => {
        state.status = 'loading'
        state.message = null
        state.errors = null
      })
      .addCase(addComment.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(addComment.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = Object.values(action.payload.errors).flat()
      })

    // ** Delete Schedule
    builder
      .addCase(deleteComment.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(deleteComment.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(deleteComment.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = action.payload.errors
      })
  }
})

export const { resetSingleSchedule, resetStateIdele } = ScheduleSlice.actions

export default ScheduleSlice.reducer